import React, { useEffect, useState } from "react";
import { Banner } from '../../components';
import { ClientsRow } from '../../components';
import { HeroIndustries } from '../../components';
import { IndustriesSpriteJpg } from '../../components';
import { IndustriesIframeBlock } from '../../components';
import { VideoFullSection } from '../../components';
import { VideoScroll } from '../../components';
import { IndustriesCarouselMenu } from '../../components';
import { VideoScrollAlone } from '../../components';
import { Loader } from '../../components';
import { imagesArray } from '../../sprites/Fashion';
import { BaseUrl } from "../../config";

const LandingFashionContainer = (props) => {
  
  const boxesArray = [
    {
      title: "Highest Quality",
      text: "Our ultra-realistic real-time rendered 3D Digital Twins are compliant to the most stringent of industry standards and created through our patented pipeline methodologies."
    },
    {
      title: "Active Experience",
      text: "We bring the digital experience to the highest level, comparable to the real-world experience where users can fully engage with the environment, products, and assets."
    },
    {
      title: "Growth Acceleration",
      text: "Transform and boost your business and company towards a “digital culture” and enable yourself to experience the enhanced opportunities of the full digital ecosystem."
    }
  ];
  

  const imgHeroIndustries = require('../../assets/hero-fashion.png');
  const imgposterVideoBis = require('../../assets/video/video-test-bis-poster.jpg');
  const imgposterVideo = require('../../assets/video/video-test-poster.jpg')

  const sprites = imagesArray;
  const arrayLoad = [
    imgHeroIndustries,
    imgposterVideoBis,
    imgposterVideo,
    ...sprites
  ]

  
  const [listClients, setListClients] = useState([]);

  useEffect(() => {
    document.title = 'Invrsion for Fashion'
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=fashion`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setListClients(res.data.company.clients);
    })
    
    
  }, []);

  return (
    <React.Fragment>
      <HeroIndustries 
        title="A new era for Fashion starts here."
        bgColor="linear-gradient(105.88deg, rgba(218, 96, 124, 1), rgba(232, 162, 178, 1) )"
        img={imgHeroIndustries}
     />
      <IndustriesSpriteJpg 
        idScroll="1!" 
        title="How our Full Reality solutions fulfill your needs" 
        black="#390909"
        boxesArray={boxesArray}
        imagesArray={sprites}
        iframeUrl="https://sketchfab.com/models/309fddfb118944e8bab43519470fbacb/embed?annotations_visible=0&amp;camera=0&amp;animation_autoplay=0&amp;autostart=0&amp;ui_controls=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_stop=0&amp;ui_watermark=0&amp;ui_watermark_link=0&amp;preload=1&amp;scrollwheel=0&amp;sound_enable=0&amp;ui_animations=0&amp;ui_annotations=0&amp;ui_ar=0&amp;ui_fadeout=0&amp;ui_fullscreen=0&amp;ui_help=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_settings=0&amp;ui_stop=0&amp;ui_theatre=0&amp;ui_vr=0&amp;pixel_budget=0"
      />
      <IndustriesIframeBlock 
        bgColor="#E8A2B2"
        url="67a582a5046a4f91a08975263a0f0584"
        title="3D e-commerce"
        black="#390909"
        zoom="130"
        route="/3d-e-commerce"
        mobileSrc={require('../../assets/iframe-placeholder/Bally_Backpack.png')}
        text="Our solution to transform your online fashion goods into Full Reality 3D models for maximum engagement. Manipulate and see every detail of your products come to life, thanks to our house blend of advanced digitization techniques."
      />
      <VideoFullSection 
        bgColor="#F6DAE0"
        title="Virtual Showroom"
        black="#390909"
        route="/virtual-showroom"
        zIndex={2}
        text="Our solution to immerse your customers in the Full Reality of your fashion brand. Allowing you to build and customize the virtual store, stage, or runway of your brand’s wildest imagination while giving your fashion content the context it deserves."
      >
        <VideoScroll 
          idScroll="video-01" 
          video={require('../../assets/video/video-fashion.mp4')} 
        />
      </VideoFullSection>
      
      <IndustriesCarouselMenu
        colorCTA="#DA607C"
        black="#390909"
      >
        <h3 className="big--title" style={{color: '#390909'}}>
          We want to get fashion ready for a high-bandwidth world
        </h3>
      </IndustriesCarouselMenu>
      <VideoScrollAlone
        idScroll="video-bis-01"
        video={require('../../assets/video/video-case-fashion.mp4')} 
      />
      {
       (listClients && listClients.length > 0) &&
        <ClientsRow 
          black="#390909"
          title="Fashion brands that are already on board and trust in Invrsion's solutions"
          arrayClients={listClients} />
      }
      
      <Banner bgColor="#FFEDF1" text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" black="#390909"/>
      <Loader arrayLoad={arrayLoad} />
    </React.Fragment>
  );
};

export default LandingFashionContainer;
